<template>
  <div class="container-fluid text-center">
    <h6 class="mb-4">Selecione uma empresa</h6>
    <div class="d-flex flex-wrap justify-content-center">
      <div class="card-empresa" v-for="e in empresas">
        <a href="javascript:" class="card text-dark text-decoration-none shadow-sm mb-3" @click="acessar(e)">
          <div class="card-body py-3">
            <div class="img-empresa mb-3">
              <img :src="e.url_imagem || `${base_cdn}/lecard-corporativo/static/imgs/default.png`" alt="Logo">
            </div>
            <div class="small m-0 text-ellipsis">{{e.nome_fantasia}}</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectEmpresas",
  props: ['salvar'],
  data() {
    return {
      token: localStorage.getItem('key'),
    }
  },
  computed: {
    empresas() {
      return this.$store.state.empresas
    },
  },

  methods: {
    acessar(e) {
      if (this.salvar) {
        if (e.isDefault) {
          this.$emit('acessarEmpresa', e);
          return;
        }

        this.$store.state.load = "Alterando empresa..";
        this.$http.post("adm/acesso/" + this.token, { id_empresa: e.id_empresa })
          .then(res => {
            this.$store.state.load = null;
            localStorage.setItem('token', e.token);
            this.$store.state.dataUser.nome_fantasia = e.nome_fantasia;
            this.$store.state.empresas.forEach(empresa => empresa.isDefault = (empresa.id_empresa === e.id_empresa));
            this.$emit('acessarEmpresa', e);

          }, res => {
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });

      } else {
        this.$emit('acessarEmpresa', e);
      }
    }
  }
}
</script>

<style scoped>
.img-empresa {
  width: 100%;
  height: 90px;
  border-radius: 6px;
  background-color: var(--primary);
  overflow: hidden;
}

.img-empresa img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.4s;
}

.card-empresa {
  width: 150px;
  margin: 4px 8px;
}

.card-empresa .card:hover img {
  transform: scale(1.2);
}

.card-empresa .card:hover h6 {
  color: var(--primary);
  font-weight: 500;
}
</style>